<template>
	<div class="container">
		<div class="row">
			<div class="col-lg-4">
				<h2 class="h h--2 h--dark">Nagrody {{contest.name}}</h2>
				<p class="paragraph">Poznaj i zamawiaj nagrody, jakie przygotowaliśmy w kategorii {{prizeGroup.name}}.</p>
				
				<user-points-info-widget/>

				<p class="paragraph"><router-link :to="{name: 'MyPrizes'}" class="">Zamówione nagrody &raquo;</router-link></p>

				<p class="paragraph">
					UWAGA! Zamówione nagrody
					stanowią dochód i podlegają
					opodatkowaniu.
					Masz pytania? Skontaktuj się
					z Koordynatorem Geberit Pro.
				</p>
			</div>
			<div class="col-lg-8 prizes__wraper" v-bind:class="{'pending': pagination.pending}">
				<a @click="$router.go(-1)" class="button button--small button--filled-blue prizes__back-to-list-anchor">&laquo; Wróć</a>
				<h3 class="prizes__heading">{{prizeGroup.name}}</h3>

				<div class="row row-eq-height prizes__list">
					<div class="col-md-6 col-lg-3 prizes__grouped" v-for="prizeCategory in prizeCategories">
						<div class="prizes__item">
							<div class="prizes__item-img">
								<img v-if="prizeCategory.photos.length > 0" v-auth-image="'/photos/'+ prizeCategory.photos[0].id + '?thumbnail=300'"/>
								<img v-else src="../../../assets/img/bezpieczenstwo_ubezpieczenie.png" alt="" />
							</div>
							<div class="prizes__item-desc prizes__item-desc--sm">
								<p>{{prizeCategory.name}}</p>
								<div class="prizes__item-footer">
									<router-link
									:to="{name: 'PrizeCategory', params: { contest_id: contest.id,  prize_group_id: prizeGroup.id,  prize_subgroup_id: prizeCategory.id }}"
									class="button button--small button--blue prizes__item-button">
									Przejdź &raquo;
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<page-box-set-widget prizes="true"></page-box-set-widget>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import Vue2Filters from 'vue2-filters'
	import { store } from '@/app/store'

	export default {
		name: 'PrizeGroupComponent',
		mixins: [Vue2Filters.mixin],
		data () {
			return {
				prizes: [],
				pagination: {},
				contest: {},
				prizeGroup: {},
				prizeCategories: {}
			}
		},
		beforeRouteEnter(to, from, next) {
			Vue.axios({
				method: "get",
				url: '/contests/groups/' +to.params.contest_id+ '/' + to.params.prize_group_id
			}).then((contestReponse) => {
				next(vm => {
					vm.contest = contestReponse.data.data.contest;
					vm.prizeGroup = contestReponse.data.data.prizeGroup;
					vm.prizeCategories = contestReponse.data.data.prizeCategories;
					return vm.contest, vm.prizeGroup, vm.prizeCategories;
				});
			})
			.catch(error => next(false));
		},
		computed: {
			user() {
				return this.$store.state.user
			},
		},
		mounted: function() {
			if( !this.user || this.user.id != 1 ) {
				this.$gtag.pageview({
					page_path: '/nagrody',
				})
			}
		},
		methods: {
			handleOk (evt) {
				// Prevent modal from closing
				evt.preventDefault()
				if (!this.name) {
					alert('Please enter your name')
				} else {
					this.handleSubmit()
				}
			},
			handleSubmit () {
				this.names.push(this.name)
				this.clearName()
				this.$refs.modal.hide()
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/app/home/prizes/PrizeGroupComponent.vue